import { useState, useCallback, useMemo } from 'react';

export interface TimelineScale {
  /** Pixels per second — the zoom level */
  pixelsPerSecond: number;
  /** Total duration in seconds */
  duration: number;
  /** Total width of the track area in pixels */
  totalWidth: number;
  /** Convert a time (seconds) to an x pixel position */
  timeToX: (time: number) => number;
  /** Convert an x pixel position to time (seconds) */
  xToTime: (x: number) => number;
  /** Zoom in/out */
  setPixelsPerSecond: (pps: number) => void;
}

export function useTimelineScale(duration: number): TimelineScale {
  const [pixelsPerSecond, setPixelsPerSecond] = useState(80);

  const totalWidth = duration * pixelsPerSecond;

  const timeToX = useCallback(
    (time: number) => time * pixelsPerSecond,
    [pixelsPerSecond],
  );

  const xToTime = useCallback(
    (x: number) => x / pixelsPerSecond,
    [pixelsPerSecond],
  );

  return useMemo(
    () => ({ pixelsPerSecond, duration, totalWidth, timeToX, xToTime, setPixelsPerSecond }),
    [pixelsPerSecond, duration, totalWidth, timeToX, xToTime],
  );
}
